import { UrlQueryMatchTypeEnum } from "../enums";
import { IOldSystemMappingInfo } from "../models";

const homePath: IOldSystemMappingInfo = {
  sourcePath: "/",
  sourceQueryMatchMode: UrlQueryMatchTypeEnum.BY_PATH_EXACT_ANY_QUERY,
  targetPathAndQuery: "/default.asp",
};

// const bookingsWithDates: IOldSystemMappingInfo = {
//   id: 4,
//   sourcePath: "/bookings",
//   sourceQuery:
//     "?date1=2023-07-10T21%3A00%3A00.000Z&date2=2023-07-21T21%3A00%3A00.000Z",
//   sourceQueryMatchMode: UrlQueryMatchTypeEnum.PATH_AND_QUERY_EXACT,
//   targetPathAndQuery: "/bookings.old?2023-07-10_2023-07-21",
//   description: "booking with dates exact",
// };
//
// const bookingsIncludePathFallback: IOldSystemMappingInfo = {
//   id: 3,
//   sourcePath: "bookings",
//   sourceQuery: undefined,
//   sourceQueryMatchMode: UrlQueryMatchTypeEnum.BY_PATH_INCLUDES,
//   targetPathAndQuery: "/old_rides_fallback_any.asp",
//   description: "fallback for any path including bookings",
// };

const simpleRouteMappings: Record<string, string> = {
  additions: "admin_additions.asp",
  areas: "admin_areas.asp",
  bookings: "set.asp",
  business_units: "admin_bunits.asp",
  courses: "admin_orders.asp?ordersview=courses",
  day_types: "admin_holidays.asp",
  drivers: "admin_drivers.asp",
  feedbacks: "admin_complains.asp",
  map: "livemap.asp",
  meals: "admin_foodsuppliers.asp",
  passenger_types: "admin_workertypes.asp",
  passengers: "admin_workers.asp",
  price_rates: "admin_courserates.asp",
  produce_buttons: "admin_producebuttons.asp",
  reasons: "admin_reasons.asp",
  ride_types: "admin_ordertypes.asp",
  rides: "admin_orders.asp",
  shift_templates: "admin_weekplan.asp",
  shifts: "admin_shifts.asp",
  sites: "admin_sites.asp",
  stations: "admin_stations.asp",
  suppliers: "admin_suppliers.asp",
  system_managers: "admin_buusers.asp",
  system_params: "admin_busettings.asp",
  units: "admin_units.asp",
  vehicles: "admin_cars.asp",
};

const simpleRouteMappingsDefinitions = Object.entries(simpleRouteMappings).map(
  ([newPath, oldPath]) => {
    return {
      sourcePath: `/${newPath}`,
      sourceQueryMatchMode: UrlQueryMatchTypeEnum.BY_PATH_EXACT_NO_QUERY,
      targetPathAndQuery: `/${oldPath}`,
    } as IOldSystemMappingInfo;
  },
);

/* path orders matters, as in routes */
export const oldSystemUrlMappings: IOldSystemMappingInfo[] = [
  homePath,
  ...simpleRouteMappingsDefinitions,
];
